window.abp = abp || { notify: {}};
(function () {

    /* DEFAULTS *************************************************/

    var defaultOptions = {
        position: 'top-end',
        showConfirmButton: false,
        timer: 3500,
        timerProgressBar: true,
        toast: true,
        showCloseButton: true,
        customClass: {
            popup: 'modern-toast-popup',
            title: 'modern-toast-title',
            htmlContainer: 'modern-toast-html',
            closeButton: 'modern-toast-close',
            timerProgressBar: 'modern-toast-progress'
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    };

    /* NOTIFICATION *********************************************/

    var showNotification = function (type, message, title, options) {
        var icon = options.imageClass ? '<i class="' + options.imageClass + ' modern-toast-icon"></i> ' : '';

        // Sempre colocar ícone + mensagem no html
        options.html = icon + message;

        // Se tiver título, usar separado
        if (title) {
            options.title = title;
        }

        var combinedOptions = Object.assign({}, defaultOptions, options);
        Swal.fire(combinedOptions);
    };

    abp.notify.success = function (message, title, options) {
        showNotification('success', message, title,
            Object.assign({
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                imageClass: 'fa fa-check-circle'
            }, options));
    };

    abp.notify.info = function (message, title, options) {
        showNotification('info', message, title, Object.assign({
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            imageClass: 'fa fa-info-circle'
        }, options));
    };

    abp.notify.warn = function (message, title, options) {
        showNotification('warning', message, title, Object.assign({
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            imageClass: 'fa fa-exclamation-triangle'
        }, options));
    };

    abp.notify.error = function (message, title, options) {
        showNotification('error', message, title, Object.assign({
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            imageClass: 'fa fa-times-circle'
        }, options));
    };

})();
